import { Map, fromJS } from 'immutable';

export function request(state, { id, selection }) {
    let items = state.get('items') || Map();

    id = id || selection.id;

    items = items.set(
        id,
        items.get(id).set('_state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();

    items = items.set(
        id,
        items.get(id)
            .set('_state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('items', items);
}

export function finish(state, { id, selection }) {
    let items = state.get('items') || Map();

    selection._state = 'FINISHED';

    return state.setIn([ 'items', id ], fromJS(selection));
}

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach((selection) => {
        let item = items.get(selection.id) || Map();

        for (const limit in selection.betLimits) {
            selection.betLimits[limit] =  selection.betLimits[limit] ? +selection.betLimits[limit] / 100 : null;
        }
        items = items.set(selection.id, item.merge(fromJS(selection)));
    });

    return state.set('items', items);
}
